import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5
    },
});

export default function IdeaSelector(props) {
    const classes = useStyles();

    const onSelectionChange = (event) => {
        props.onSelectionChange(
            event.target.value
        );
    };

    return (
        <div className={classes.root}>
            <FormControl component="fieldset">
                <RadioGroup
                    row
                    aria-label={props.label}
                    name={props.label}
                    defaultValue="any"
                    onChange={onSelectionChange}
                >
                    {props.ideaOptions.map( (idea, index) => {
                        return <FormControlLabel
                            key={index}
                            value={idea.idea}
                            style={{color: idea.color}}
                            control={<Radio/>}
                            label={idea.idea}
                        />;
                    })}
                </RadioGroup>
            </FormControl>
        </div>
    );
}
